const LAYOUT = "error";

export enum EHTTPError {
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
}

export type TErrorAction = "back" | "home" | "logout";

const LOCALE = "generic.pageError.";

export const ERROR_ACTION_LABELS: Record<TErrorAction, string> = {
  back: `${LOCALE}goBack`,
  home: `${LOCALE}goToHomepage`,
  logout: "generic.navbar.menuUser.logout",
};

export function getErrorContent(errorCode: EHTTPError, action: TErrorAction = "back") {
  return {
    layout: LAYOUT,
    title: `${LOCALE}${errorCode}.title`,
    content: {
      code: errorCode,
      title: `${LOCALE}${errorCode}.title`,
      text: `${LOCALE}${errorCode}.text`,
      subText: `${LOCALE}${errorCode}.subText`,
      action,
    },
  };
}
